import { FETCH_ISSUE_TIMELINE_SUCCESS, FetchIssueTimelineSuccessAction } from '@/actions/triage';
import { TimelineEvent } from '@/types';

export type IssueTimelinesByIssueId = Record<string, TimelineEvent[]>;

export function issueTimelinesReducer(
    state: IssueTimelinesByIssueId = {},
    action: FetchIssueTimelineSuccessAction,
): IssueTimelinesByIssueId {
    switch (action.type) {
        case FETCH_ISSUE_TIMELINE_SUCCESS:
            return { ...state, [action.payload.issueId]: action.payload.events };
        default:
            return state;
    }
}

export default issueTimelinesReducer;
